import { DestroyRef, Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '../app.config.token';
import { DOCUMENT } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private http = inject(HttpClient);
  private config = inject(APP_CONFIG);
  private lastLogTime = 0;
  private readonly THROTTLE_MS = 2000; // Simple client-side throttle
  private document = inject(DOCUMENT);
  private destroyRef = inject(DestroyRef);

  logError(error: unknown): void {
    const now = Date.now();
    if (now - this.lastLogTime < this.THROTTLE_MS) {
      return;
    }
    this.lastLogTime = now;

    const message = this.formatMessage(error);
    const stack = error instanceof Error ? error.stack || '' : '';

    const payload = {
      level: 'error',
      message: message.substring(0, 2000),
      stack: stack.substring(0, 5000),
      url: this.document.location.href,
      userAgent: navigator.userAgent.substring(0, 500),
    };

    this.http
      .post(`${this.config.apiUrl}/logs`, payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: (err) =>
          console.warn('Failed to send error log to backend', err),
      });
  }

  private formatMessage(error: unknown): string {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return error.message;
    try {
      return JSON.stringify(error);
    } catch {
      return 'Unknown Error (Circular JSON?)';
    }
  }
}
